import Module from './blogPost'
export default Module
